import React from 'react';
import { connect } from 'react-redux';
import Highcharts from 'highcharts';

import dateUtils from '../../../util/dates';
import dataUtils from '../../../util/dataUtils';
import highchartFactory from '../../../util/highcharts';
const highchartUtils = highchartFactory();

const chartConfig = {
  exporting: {
    enabled: false,
  },
  credits: {
    enabled: false,
  },
  chart: {
    backgroundColor: '#fff',
    type: 'column',
  },
  title: {
    text: '',
  },
  xAxis: {
    type: 'datetime',
    ordinal: false,
    labels: {
      style: {
        fontSize: '5px',
      },
    },
    tickmarkPlacement: 'on',
    title: {
      enable: false,
    },
  },
  yAxis: {
    opposite: false,
    allowDecimals: false,
    labels: {
      style: {
        fontSize: '6px',
      },
    },
    min: 0,
    gridLineColor: '#F5F5F5',
    gridLineWidth: 1,
    title: {
      enabled: false,
    },
  },
  legend: {
    enabled: false,
  },
  tooltip: {
    enabled: false,
  },
  plotOptions: {
    series: {
      stickyTracking: false,
    },
    column: {
      stacking: 'normal',
      pointPadding: 0,
      borderWidth: 2,
      groupPadding: 0,
      shadow: false,
      pointRange: 24 * 3600 * 1000,
    },
  },
  series: [
    {
      name: 'Data',
      data: [],
    },
  ],
};

class ThroughputChart extends React.Component {
  componentDidMount() {
    this.chart = new Highcharts['Chart'](`${this.props.id}-details`, chartConfig);

    this.updateTimeLabelsFormat(this.props.dateFormat);

    if (this.props.data && this.props.data.length) {
      this.updateChart();
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.data != this.props.data) {
      this.updateChart(prevProps.data);
    }

    if (prevProps.dateFormat != this.props.dateFormat) {
      this.updateTimeLabelsFormat(this.props.dateFormat);
    }
  }

  componentWillUnmount() {
    this.chart.destroy();
  }

  updateChart(oldData = []) {
    const diff = dataUtils.getDiff(oldData, this.props.data, 'data');
    highchartUtils.updateSeries(diff, this.chart);
    this.chart.redraw();
  }

  updateTimeLabelsFormat(dateFormat) {
    let config = { xAxis: {} };
    config.xAxis.dateTimeLabelFormats = dateUtils.createHighchartFormats(dateFormat);

    this.chart.update(config);
  }

  render() {
    return (
      <div id={this.props.id} className={this.props.className}>
        <div>
          <div id={`${this.props.id}-details`}></div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    colorsEnabled: state.filters.trc.colorsEnabled,
    timeUnit: state.filters.trc.timeUnit,
    dateFormat: state.filters.dateFormat,
  };
};

export default connect(mapStateToProps)(ThroughputChart);
